<ng-template #usersSidenavActions>
  <div class="sidenav-section">
    <h4 class="sidenav-heading">Users Actions</h4>
    <div class="sidenav-actions">
      <button mat-button color="primary" (click)="createNewUser()" [disabled]="isViewer()">
        New User
      </button>
    </div>
  </div>
  <mat-divider></mat-divider>

  <div class="sidenav-section">
    <h4 class="sidenav-heading">Downloads</h4>
    <div class="sidenav-actions">
      <button mat-button color="primary" (click)="exportCSV()">
        CSV
      </button>
      <button mat-button color="primary" (click)="exportExcel()">
        Download as Excel
      </button>
    </div>
  </div>
  <mat-divider></mat-divider>

  <div class="sidenav-section">
    <h4 class="sidenav-heading">View</h4>
    <div class="sidenav-actions">
      <button mat-button color="primary" (click)="openCustomizeColumnsDialog()">
        Customize Columns
      </button>
      <button mat-button color="primary" (click)="toggleFloatingFilters()">
        {{ showFloatingFilters ? 'Hide' : 'Show' }} Filter Row
      </button>
      <button mat-button color="primary" type="button" (click)="saveView()">
        Save As Default View
      </button>
      <button mat-button color="primary" (click)="showSaveNamedView()">
        Save Custom View Now
      </button>
      <button mat-button color="primary" type="button" (click)="openSavedReportsDialog()">
        Open Saved Views
      </button>
      <button mat-button color="primary" type="button" (click)="openDeleteSavedViewsDialog()">
        Delete Saved Views
      </button>
      <button mat-button color="primary" type="button" (click)="openShareViewDialog()" [disabled]="userRole === 'Viewer'">
        Share View
      </button>
    </div>
  </div>
</ng-template>

<mat-sidenav-container class="example-container">
  <mat-sidenav #sidenav mode="side" class="sidenav-padding">
    <ng-container *ngTemplateOutlet="usersSidenavActions"></ng-container>
  </mat-sidenav>

  <mat-sidenav-content>
    <div class="top-toolbar-actions">
      <div class="search-section">
        <input
          type="text"
          class="filter-control"
          (input)="onSearchChange($any($event.target).value)"
          placeholder="Find..."
        />
      </div>

      @if (filtersApplied) {
        <div class="filters-indicator">
          <mat-icon>filter_list</mat-icon>
          <span>Filters Applied</span>
          <button mat-button color="warn" (click)="removeAllFilters()">
            Remove All Filters
          </button>
        </div>
      }

      @if (hasUnsavedChanges) {
        <div class="unsaved-changes-indicator">
          <mat-icon>edit</mat-icon>
          <span>Unsaved Changes</span>
        </div>
      }

      <div class="refresh-section">
        @if (waitingForServer) {
          <mat-spinner diameter="50"></mat-spinner>
        }
      </div>

      @if (showNameSavedView) {
        <div class="save-view-section">
          <mat-form-field appearance="fill" class="full-width">
            <mat-label>Name this custom view</mat-label>
            <input
              matInput
              [(ngModel)]="nameOfSavedView"
              name="nameOfSavedView"
            />
          </mat-form-field>
          <button mat-flat-button color="primary" (click)="saveNamedViewNow()">
            Save
          </button>
        </div>
      }

      @if (customizeColumnsUi) {
        <div class="customize-columns-section">
          <h3>Customize Columns</h3>

          <!-- Selected columns as chips -->
          <div class="selected-columns-chips">
            <mat-chip-set aria-label="Selected columns">
              @for (column of selectedColumnsList; track column.colId) {
                <mat-chip (removed)="removeColumn(column)">
                  {{ column.headerName }}
                  <button matChipRemove>
                    <mat-icon>cancel</mat-icon>
                  </button>
                </mat-chip>
              }
            </mat-chip-set>
          </div>

          <!-- Autocomplete to add columns -->
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Search and select columns</mat-label>
            <input
              type="text"
              matInput
              [formControl]="columnSelectorControl"
              [matAutocomplete]="autoColumns"
              placeholder="Type to search..."
            />
            <mat-autocomplete
              #autoColumns="matAutocomplete"
              [displayWith]="displayColumnFn"
              (optionSelected)="selectColumn($event.option.value)"
            >
              @for (option of filteredColumns$ | async; track option.value.colId) {
                <mat-option [value]="option.value">
                  {{ option.viewValue }}
                </mat-option>
              }
            </mat-autocomplete>
          </mat-form-field>

          <!-- Action buttons -->
          <div class="customize-columns-actions">
            <button mat-raised-button color="primary" (click)="applyColumns()">
              Apply
            </button>
            <button mat-button (click)="customizeColumnsUi = false">
              Cancel
            </button>
          </div>
        </div>
      }
    </div>

    <!-- Loading overlay while grid initializes -->
    @if (isInitializing) {
      <div class="grid-loading-overlay">
        <mat-spinner diameter="60"></mat-spinner>
        <p>Loading your view...</p>
      </div>
    }

    <!-- Grid (hidden during initialization) -->
    <div [style.visibility]="isInitializing ? 'hidden' : 'visible'">
      <ag-grid-angular
        style="width: 100%; height: 800px"
        class="ag-theme-balham"
        [defaultColDef]="defaultColDef"
        [rowData]="allUsers$ | async"
        [columnDefs]="selectedCols"
        (gridReady)="onGridReady($event)"
        (cellClicked)="onCellClicked($event)"
      >
      </ag-grid-angular>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
